import React from "react";
import './ProductSugar.css'
import as2 from "./image/AS2.jpg";
import drop from "./image/DropForgedChain.jpg";
import fabricate from "./image/FabricatedRakeCarrierChain.jpg";
import forged from "./image/ForgedRakeElevator.jpg";
import inter from "./image/InterCarrierChain.jpg";
import k2 from "./image/K2Attachment.jpg";
import s1 from "./image/S1Attachment.jpg";
import slates from "./image/Slates.jpg";
import sugar from "./image/SugarBagStaker.jpg";
import sugarelevator from "./image/sugarElevatorChains.jpg";

const ProductSugar = () => {
  return (
    <div>
      <div className="sugarap">
        <p className="p">Sugar Factory</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Sugar Factory</p> */}
        </div>
      </div>

      <div className="sugara">
        <div className="auimg">
          <figure>
            <img src={as2} alt="Conveyor Chain SWAJIT 4601" />
            <figcaption>Conveyor Chain SWAJIT 4601</figcaption>
          </figure>
        </div>

        <div className="suimg">
          <figure>
            <img
              src={drop}
              alt="Conveyor Chain for Varnishing Machine SWAJIT 4401"
            />
            <figcaption>
              Conveyor Chain for Varnishing Machine SWAJIT 4401
            </figcaption>
          </figure>
        </div>

        <div className="suimg">
          <figure>
            <img src={fabricate} alt="CoolingBed Conveyor Chain SWAJIT 4501" />
            <figcaption>CoolingBed Conveyor Chain SWAJIT 4501</figcaption>
          </figure>
        </div>

        <div className="suimg">
          <figure>
            <img src={forged} alt="Draw Bech Chain SWAJIT 4001" />
            <figcaption>Draw Bech Chain SWAJIT 4001</figcaption>
          </figure>
        </div>
      </div>

      <div className="sugar-two">
        <div className="sumg">
          <figure>
            <img src={inter} alt="Mandrel Bar Insert Chain SWAJIT 4301" />
            <figcaption>Mandrel Bar Insert Chain SWAJIT 4301</figcaption>
          </figure>
        </div>
        <div className="suimg">
          <figure>
            <img src={k2} alt="Mandrel Extractor Chain SWAJIT 4201" />
            <figcaption>Mandrel Extractor Chain SWAJIT 4201</figcaption>
          </figure>
        </div>

        <div className="suimg">
          <figure>
            <img src={s1} alt="Shell Pusher Chain" />
            <figcaption>Shell Pusher Chain</figcaption>
          </figure>
        </div>

        <div className="suimg">
          <figure>
            <img src={slates} alt="Shell Pusher Chain SWAJIT 4101" />
            <figcaption>Shell Pusher Chain SWAJIT 4101</figcaption>
          </figure>
        </div>

        
      </div>
      <div className="sugar-two">
      <div className="suimg">
          <figure>
            <img src={sugar} alt="Shell Pusher Chain SWAJIT 4101" />
            <figcaption>Shell Pusher Chain SWAJIT 4101</figcaption>
          </figure>
        </div>

        <div className="suimg">
          <figure>
            <img src={sugarelevator} alt="Shell Pusher Chain SWAJIT 4101" />
            <figcaption>Shell Pusher Chain SWAJIT 4101</figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default ProductSugar;
